module.exports = __webpack_public_path__ + "img/logo-with-name.e1f947ff.webp";